import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import DisclaimerModal from "./DisclaimerModal";
import Watermark from "./Watermark";
import FloatingWhatsApp from "./FloatingWhatsApp";
import AcademyShareButton from "./AcademyShareButton";
import AutoTranslateDOM from "./AutoTranslateDOM";
import InstallAppPrompt from "./InstallAppPrompt";
import { useDisclaimer } from "../context/DisclaimerContext";
import useVisitTracker from "../hooks/useVisitTracker";

const Layout = () => {
  const { accepted } = useDisclaimer();
  useVisitTracker();

  return (
    <div className="min-h-screen flex flex-col relative">
      <DisclaimerModal />

      {/* Subtle brand watermark on every page (behind all content) */}
      {accepted && <Watermark />}

      <div
        className={`flex-1 flex flex-col transition-all duration-700 relative z-10 ${
          accepted ? "opacity-100" : "opacity-30 pointer-events-none blur-sm"
        }`}
      >
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
      {accepted && <FloatingWhatsApp />}
      {accepted && <AcademyShareButton />}
      <AutoTranslateDOM />
      {accepted && <InstallAppPrompt />}
    </div>
  );
};

export default Layout;
